import { fetch as fetchPolyfill } from 'whatwg-fetch';
import { DateTime } from 'luxon';

import { loadWidget } from '../utils/load-widget';

loadWidget('package-group', {
    props: {
        'packageNo': String,
    },
    data: function() {
        return {
            ViewModel: {
                PackageNo: undefined,
                Performances: [],
                Loading: true,
            }
        };
    },
    methods: {
        cloudinaryUrl: function (imageUrl, width, height) {
            return imageUrl.replace(/h_\d+/, `h_${height}`).replace(/w_\d+/, `w_${width}`);
        },
        getDateDescription(event) {
            const date = DateTime.fromISO(event.date);

            if (date.toFormat('mm') === '00') {
                return date.toFormat('ccc LLL d, yyyy \'at\' ha \'CT\'');   // "Sat Oct 22, 2022 at 8PM CT";
            }

            return date.toFormat('ccc LLL d, yyyy \'at\' h:mma \'CT\'');   // "Sat Oct 22, 2022 at 8:30PM CT";
        }
    },
    beforeMount() {
        this.ViewModel.PackageNo = parseInt(this.packageNo, 10);

        fetchPolyfill(window.AppConfig.package_feed.replace('{package_no}', this.packageNo))
            .then(res => {
                if (res.status !== 200) {
                    throw 'Package not found'
                }

                return res;
            })
            .then(res => res.json())
            .then(data => {
                this.ViewModel.Performances = data;
            })
            .finally(() => {
                this.ViewModel.Loading = false;
            });
    }
});
